import { FormattedMessage } from '@subaio/components'

import { HeaderIconError } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const Error = () => (
	<SplashScreen
		title={<FormattedMessage id='error.title' defaultMessage='An unexpected error has occurred' />}
		icon={<HeaderIconError />}
	/>
)
